import API from "../../api";

export const getAdministrator = agency_code => {
  return API.agent().get(`/agencies/${agency_code}/producers/administrator`);
};
